import { render, staticRenderFns } from "./Level4Category.vue?vue&type=template&id=60d7c8f8&"
import script from "./Level4Category.vue?vue&type=script&lang=js&"
export * from "./Level4Category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports